import { Box, Paper } from '@mui/material';
import type { PropsWithChildren } from 'react';
import { discoveryPaperCardSx } from './styles';

type DiscoveryPaperCardProps = PropsWithChildren<{
  sx?: Record<string, unknown>;
}>;

export const DiscoveryPaperCard = ({
  children,
  sx,
}: DiscoveryPaperCardProps) => (
  <Box
    sx={{
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: { xs: 'center', md: 'stretch' },
      justifyContent: { xs: 'center', md: 'flex-start' },
    }}
  >
    <Paper sx={{ ...discoveryPaperCardSx, ...(sx ?? {}) }}>{children}</Paper>
  </Box>
);
